import React, { useEffect } from 'react';
import { Monitor } from 'lucide-react';

const MobileWarningPage = () => {
  // Mark that user has been to mobile warning page (they "sinned")
  useEffect(() => {
    sessionStorage.setItem('mobileWarningShown', 'true');
  }, []);

  // Check if user has switched to desktop mode and redirect
  useEffect(() => {
    const checkDesktopMode = () => {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // If user agent no longer shows mobile (desktop mode enabled), redirect to start over
      if (!isMobile) {
        // Clear the flag and redirect
        sessionStorage.removeItem('mobileWarningShown');
        window.location.replace('https://poa.tcauditors.co.za');
      }
    };

    // Check immediately
    checkDesktopMode();

    // Also check frequently in case user enables desktop mode while on this page
    const interval = setInterval(checkDesktopMode, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white flex items-center justify-center p-6">
      <div className="max-w-2xl w-full text-center">
        {/* Icon */}
        <div className="mb-8">
          <Monitor className="w-24 h-24 text-orange-500 mx-auto" strokeWidth={1.5} />
        </div>
        
        {/* Main Heading */}
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
          Desktop Mode Required
        </h1>
        
        {/* Main Message */}
        <p className="text-xl sm:text-2xl text-gray-600 mb-8">
          For the best viewing experience of your SARS Power of Attorney, please switch to Desktop Mode on your phone's browser.
        </p>
        
        {/* Tip */}
        <p className="text-xl sm:text-2xl text-gray-600 mb-8">
          Tip: Tap the menu icon (⋮) in your phone's browser and select 'Desktop Site'.
        </p>
        
        {/* Divider */}
        <div className="w-24 h-1 bg-orange-500 mx-auto mb-8"></div>
        
        {/* Note */}
        <p className="text-lg text-gray-500">
          Once enabled, this page will automatically redirect you to the Power of Attorney.
        </p>
        
        {/* TCA Logo */}
        <div className="mt-12">
          <img 
            src="/images/TCA_Logo.png" 
            alt="TCA Auditors" 
            className="h-16 mx-auto opacity-60"
          />
        </div>
      </div>
    </div>
  );
};

export default MobileWarningPage;
